<div class="appointment-tooltip">
  <div class="title">{{ selectedAppointmentData['text'] }}</div>
  <div class="content">
    <div class="date">
      <dx-button
        icon="clock"
        [focusStateEnabled]="false"
        [activeStateEnabled]="false"
        [hoverStateEnabled]="false"
      ></dx-button>
      {{ getTimeString(selectedAppointmentData) }}
    </div>
    <div *ngIf="selectedAppointmentData['description']" class="description">
      <dx-button
        icon="textdocument"
        [focusStateEnabled]="false"
        [activeStateEnabled]="false"
        [hoverStateEnabled]="false"
      ></dx-button>
      {{ selectedAppointmentData['description'] }}
    </div>
  </div>
  <div class="buttons">
    <dx-button
      class="button-danger"
      text="Sil"
      type="danger"
      stylingMode="text"
      (onClick)="clickDeleteAppointment.emit(selectedAppointmentData)"
    ></dx-button>
    <dx-button
      class="button-success"
      text="Düzenle"
      type="success"
      stylingMode="text"
      (onClick)="clickEditAppointment.emit()"
    ></dx-button>
  </div>
</div>
